import { render, staticRenderFns } from "./TrademarkAudit.vue?vue&type=template&id=e6c77a34&scoped=true"
import script from "./TrademarkAudit.vue?vue&type=script&lang=js"
export * from "./TrademarkAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c77a34",
  null
  
)

export default component.exports